import ReportRow from './ReportRow';
import ReportRangeRow from './ReportRangeRow';
import './reports.css';

/** Reports grouped by the day they were read (see utils/reportGroups). */
const ReportList = ({
  groups,
  showReader,
  selectMode,
  selectedIds,
  onToggleSelect,
  onToggleMany,
  editing,
  editActions
}) => (
  <div className="report-groups">
    {groups.map((group) => (
      <section key={group.day} className="report-day" aria-label={group.label}>
        <h3 className="report-day-label">{group.label}</h3>
        <ul className="report-list">
          {group.entries.map((entry) => (
            entry.type === 'range' ? (
              <ReportRangeRow
                key={entry.key}
                entry={entry}
                showReader={showReader}
                selectMode={selectMode}
                selectedIds={selectedIds}
                onToggleSelect={onToggleSelect}
                onToggleMany={onToggleMany}
                editing={editing}
                editActions={editActions}
              />
            ) : (
              <ReportRow
                key={entry.key}
                report={entry.report}
                showReader={showReader}
                selectMode={selectMode}
                selected={selectedIds.has(entry.report.id)}
                onToggleSelect={onToggleSelect}
                editing={editing}
                editActions={editActions}
              />
            )
          ))}
        </ul>
      </section>
    ))}
  </div>
);

export default ReportList;
